import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';

class Header extends Component {
    resetLesson = () => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to return home? Your current progress will be erased.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                this.props.dispatch({type: 'SET_ACTIVE_LESSON', payload: {}});
                this.props.dispatch({type: 'OPEN_DECISION'})
                this.props.dispatch({type: "RESET_USER_DECISION_DATA", payload: {"1": {question: '', choice: [] }, "2": {question: '', choice: [] }, "3": {question: '', choice: [] }, "4": {question: '', choice: [] }, "5": {question: '', choice: [] }, "6": {question: '', choice: [] }, "7": {question: '', choice: [] }, "8": {question: '', choice: [] }, "9": {question: '', choice: [] }}});
            } else {
              swal({icon: "success",
                  text: "Okay, continue on."});
            }
          });
    }
    render(){
        return(
        <header className="flex-box flex-between flex-nowrap">
           {/* <a href="https://chaplaincyinnovation.org/"><img src="https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/cil-logo-full-color-rgb.svg" height="50px" alt="CIL logo"/></a> */}
            <div className="flex-box flex-end flex-nowrap"><FontAwesomeIcon className="nav-icon" onClick={()=>this.resetLesson()} icon={faArrowLeft}/></div>

        </header>)
    }
}

export default connect()(Header);